import { API_URL } from '../../helpers/constants';
import request from '../../utils/request';
import { GetPriceHistoriesPayload, PriceHistories } from './types';

export const getPriceHistories = async (
  payload: GetPriceHistoriesPayload,
): Promise<PriceHistories> => {
  const { destinationCityId, originCityId, signal, timeframeDays } = payload;

  const parameters: URLSearchParams = new URLSearchParams({
    originCityId,
    destinationCityId,
  });

  for (const timeframeDay of timeframeDays) {
    parameters.append('timeframeDays', timeframeDay);
  }

  const response = await request(`${API_URL}/priceHistory?${parameters}`, {
    signal,
  });

  return response;
};
